import { mapState, mapActions } from 'vuex'
import { STORE_KEY } from './constants'
import { uploadImg } from '@/store/common/api';
import { CHANGE_TXT_QUESTION, CHANGE_TXT_ANSWER } from '@/store/common/constants';
import * as typeQuestion from '@/modules/question/preview-question/_store/constants'

export default {
  data () {
    return {
      multiCorrectCheckbox: []
    }
  },
  props: {
    positionQuestionGroup: Number,
    isQuestionGroup: Boolean,
    questionType: String
  },
  computed: {
    ...mapState(STORE_KEY, ['indexQuestionWorking', 'questionDetail', 'questionList'])
  },
  mounted () {
    this.$bus.on(`${CHANGE_TXT_QUESTION}_${this.indexQuestionWorking}`, this.handleChangeTxtQuestion)
    this.$bus.on(`${CHANGE_TXT_ANSWER}_${this.indexQuestionWorking}`, this.handleChangeTxtAnswer)
  },
  beforeDestroy() {
    this.$bus.off(`${CHANGE_TXT_QUESTION}_${this.indexQuestionWorking}`, this.handleChangeTxtQuestion)
    this.$bus.off(`${CHANGE_TXT_ANSWER}_${this.indexQuestionWorking}`, this.handleChangeTxtAnswer)
  },
  methods: {
    // ...mapActions(STORE_KEY, ['workQuestion']),
    ...mapActions('common', ['setLoading']),
    ...mapActions(STORE_KEY, ['acSetQuestionDetail']),

    setStyleQuestion(val) {
      this.acSetQuestionDetail({...this.questionDetail, layoutId: val});
    },

    changeImgAnswerItem(evt, index) {
      if (evt.target.files.length > 0) {
        let self = this;
        self.setLoading(true);
        uploadImg(evt).then(res => {
          if(!self.isQuestionGroup) {
            self.questionDetail.answers[index]['imageUrl'] = res
          } 
        }).catch().finally(() => self.setLoading(false));
      }
    },

    delImgOfAnswer(evt, index) {
      this.questionDetail.answers[index].imageUrl = ''
      this.acSetQuestionDetail({...this.questionDetail})
    },

    handleChangeTxtQuestion (val) {
      // console.log('Question content: ', val)
      this.questionDetail.content = val.html
    },

    handleChangeTxtAnswer (val) {
      // console.log('Handle change content answer: ', val)
      this.questionDetail.answers[val.answer].content = val.html
    },

    addNewAnswer () {
      let lengthAnswers = this.questionDetail.answers.length
      let answerNew = {answerId: 0, isNew: true, content: '', orderNo: lengthAnswers, correct: '', imageUrl: ''}
      this.questionDetail.answers.push(answerNew)
      this.acSetQuestionDetail({...this.questionDetail})
    },

    removeAnswer (index) {
      this.questionDetail.answers.splice(index, 1)
      this.acSetQuestionDetail({...this.questionDetail})
    },

    changeAnswerCorrect (e, data, index) {
      let self = this;
      let typeQuestionCurr = self.questionDetail.type;
      if(typeQuestionCurr === typeQuestion.TYPE_RADIO) {
        self.multiCorrectCheckbox = e;
      } else {
        if(!self.questionDetail.multiCorrectCheckbox || !Array.isArray(self.questionDetail.multiCorrectCheckbox)) {
          self.questionDetail.multiCorrectCheckbox = []
        }
        if((e || e === 0) && e > -1) {
          self.questionDetail.multiCorrectCheckbox.push(e)
        } else {
          let indexAnswer = self.questionDetail.multiCorrectCheckbox.indexOf(data.orderNo)
          indexAnswer > -1 && self.questionDetail.multiCorrectCheckbox.splice(indexAnswer, 1)
        }
      }
      self.questionDetail.answers.map(ans => {
        ans.correct && delete ans.correct;
        ans.answerContent && delete ans.answerContent;
        if(typeQuestionCurr === typeQuestion.TYPE_RADIO && ans.orderNo === parseInt(e)) {
          ans.correct = ans.content;
          ans.answerContent = ans.orderNo;
        } else if(Array.isArray(self.questionDetail.multiCorrectCheckbox) && (ans.orderNo || ans.orderNo === 0) && self.questionDetail.multiCorrectCheckbox.includes(ans.orderNo)) {
          ans.correct = ans.content;
          ans.answerContent = ans.orderNo;
        }
      })
      self.acSetQuestionDetail({...self.questionDetail})
    },
  }
}